import React from 'react';
import PropTypes from 'prop-types';
import {
  newCommentImg as NewCommentImg,
  newOwnerImg as NewOwnerImg,
  newTenderImg as NewTenderImg,
  newStatusImg as NewStatusImg,
  cardUserImg,
  logDocumentImg as LogDocumentImg,
} from 'theme/icon';
import { Comment, Owner, AddTender, Status, Files, SourceChange, SourceLost } from './type';
/*
import { Button } from 'components/UI';
import selector from 'redux_store/selectors/tenderCard/index';
import RowData from 'components/Tender/list/row/Info/index';
import Date from 'components/Tender/list/row/Date/index';
import { onSetOwner, onSetStatus } from 'redux_store/modules/tenderCard';
*/
import styles from './styles.scss';

const imageAction = Object.freeze({
  1: NewTenderImg,
  2: NewOwnerImg,
  3: NewStatusImg,
  4: NewCommentImg,
  5: LogDocumentImg,
  6: LogDocumentImg,
  9: NewTenderImg,
  13: NewTenderImg,
  14: NewTenderImg,
});

export default class Log extends React.PureComponent {
  static propTypes = {
    tenderLogId: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    actionDate: PropTypes.objectOf(PropTypes.any).isRequired,
    actionId: PropTypes.number.isRequired,
    // actionUserId: PropTypes.number.isRequired,
    actionUserName: PropTypes.string,
    changeMonth: PropTypes.bool.isRequired,
    actionName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    changes: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static defaultProps = {
    actionUserName: null,
  };

  render() {
    const {
      tenderLogId,
      actionDate,
      actionId,
      // actionUserId,
      actionUserName,
      changeMonth,
      actionName,
      changes,
    } = this.props;
    const Icon = imageAction[actionId];
    return (
      <div className={styles.log}>
        <div className={styles.logHeader}>
          <img className={styles.userImage} alt="" src={cardUserImg} />
          <div className={styles.actionUser}>{actionUserName}</div>
          <div className={styles.date}>{actionDate.format('D MMMM YYYY в HH:mm')}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.changeMonth}>
            {changeMonth && [
              <div className={styles.newMonth} key={`${tenderLogId}m`}>
                {actionDate.format('MMMM')}
              </div>,
              <div className={styles.newYear} key={`${tenderLogId}y`}>
                {actionDate.format('YYYY')}
              </div>,
            ]}
          </div>
          <div className={styles.info}>
            <div className={styles.actionImage}>
              <Icon alt="" />
            </div>
            {changes && (
              <div className={styles.card}>
                <div className={styles.actionName}>{actionName}</div>
                {actionId === 1 && <AddTender {...changes.data[0]} />}
                {actionId === 2 && <Owner {...changes.data[0]} />}
                {actionId === 3 && <Status {...changes.data[0]} />}
                {actionId === 4 && <Comment {...changes.data[0]} />}
                {actionId === 14 && <SourceLost />}
                {[5, 6].indexOf(actionId) !== -1 && <Files files={changes.data} actionId={actionId} />}
                {[9, 13].indexOf(actionId) !== -1 && <SourceChange data={changes} tenderLogId={tenderLogId} />}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
